var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"userCenter"}},[_c('van-nav-bar',{attrs:{"title":"用户中心","left-arrow":"","fixed":true,"border":true},on:{"click-left":function($event){return _vm.$router.go(-1)}}}),_c('div',{staticClass:"logout"},[_c('button',{on:{"click":_vm.logOut}},[_vm._v("退出登录")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }